module.exports = __webpack_public_path__ + "static-portal/img/news12-9.4aa90f6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news12-9.jpg
// module id = V4QW
// module chunks = 4